'use strict';

module.exports = function () {
    $('body').on('click', '[data-dropdown-header]', function (e) {
        e.preventDefault();

        var $currentDropdown = $(this).closest('[data-dropdown]');
        var dropDownFields = $('[data-dropdown-header]');

        // Iterate through each dropdown, but skip the current one
        // This is a case where there are multiple dropdowns on a page
        dropDownFields.each(function () {
            var $dropdown = $(this).closest('[data-dropdown]');
            if ($dropdown[0] !== $currentDropdown[0]) {
                $dropdown.removeClass('active');
            }
        });

        // Toggle the active class on the current dropdown
        $currentDropdown.toggleClass('active');

        e.stopPropagation();
    });

    $(document).on('click', function (e) {
        if ($(e.target).is('[data-dropdown]') === false) {
            $('[data-dropdown]').removeClass('active');
        }
    });
};
